import { render, staticRenderFns } from "./waitMove.vue?vue&type=template&id=0794a555&scoped=true&"
import script from "./waitMove.vue?vue&type=script&lang=js&"
export * from "./waitMove.vue?vue&type=script&lang=js&"
import style0 from "./waitMove.vue?vue&type=style&index=0&id=0794a555&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0794a555",
  null
  
)

export default component.exports